// Carries the visitor's landing-page draft (prompt + picked image) into the
// generation page after they become a user (anonymous or signed up).
//
// The File lives in a module variable: SPA route changes keep the module
// alive, so "dismiss nudge → guest login → navigate to /minimax-h3" hands the
// file over intact. It is lost on a hard reload — notably the full-page
// Casdoor redirect for real signup — so prompt and tab are mirrored to
// sessionStorage and at least the text survives that round-trip.

export type LandingTab = 'image-to-video' | 'text-to-video';

export type LandingDraft = {
  prompt: string;
  file: File | null;
  tab: LandingTab;
};

const STORAGE_KEY = 'happypony-landing-draft';

let draftFile: File | null = null;

export function setDraft(draft: LandingDraft): void {
  draftFile = draft.file;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ prompt: draft.prompt, tab: draft.tab })
    );
  } catch {
    // Storage unavailable (private mode quota etc.) — the in-memory file
    // handoff still works for the guest path.
  }
}

// Read-and-clear: the draft is consumed exactly once by the generation page.
export function takeDraft(): LandingDraft | null {
  let stored: { prompt?: string; tab?: string } | null = null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) stored = JSON.parse(raw) as { prompt?: string; tab?: string };
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    stored = null;
  }
  const file = draftFile;
  draftFile = null;
  if (!stored && !file) return null;
  return {
    prompt: stored?.prompt ?? '',
    file,
    tab: stored?.tab === 'image-to-video' ? 'image-to-video' : 'text-to-video',
  };
}
